import React, { useContext, useEffect, useState } from 'react'
import ScoreIconRP from '../assets/ScoreIconsRP.svg'
import Info from '../assets/IconInformation.svg'
import RewardCard from '../assets/rewardCardFreeRecharge.svg'
import RewardFreeFraisT from '../assets/RewardFreeTransfer.svg'
import RewardsFreeBillPayment from '../assets/rewardsFreeBillPayment.svg'
import Fleche from '../assets/flechebleu.svg'
import ModalInfoReward from './ModalInfoReward'
import SpendGiftModal from './SpendGiftModal'
import UserContext from 'contexts/UserContext'
import { CreateGift, GetListGift } from 'requests/game'
import { useNavigate } from 'react-router-dom'
import GiftStore from '../assets/gift-stroke.png'
import Recompense from './recompense'
interface TypeOption {
  image: string
  nbrPoint: number
  description:string
  color: string
  type: string
  redirection: string
}
const Rewards = () => {
  const { user, setUser } = useContext(UserContext)
  const [isOpenModalInfo, setIsOpenModalInfo] = useState(false)
  const [isOpenModalSpendGift, setIsOpenModalSpendGift] = useState(false)
  const [selectedPack, setSelectedPack] = useState<TypeOption >()
  const navigate = useNavigate()
  const [totalCount, setTotalCount]=useState(0)
  const [isOpenRecompense, setIsOpenRecompense] = useState(user?.user.game?.isOpenRecompense ?
             user?.user.game?.isOpenRecompense  : false)
  const [giftCount, setGiftCount]= useState([])

  const listeOffre = [
    // {image:RewardCard, nbrPoint:500, montant:'3', description:'Win 3 free Mobile Recharges', color: 'bg-[#FFC000]'},
    {
      image: RewardCard,
      nbrPoint: 600,
      description: "une recharge mobile gratuite d'une valeur inférieure à 5 €",
      color: 'bg-[#FFC000]',
      type: 'recharge',
      redirection:'/recharge'
    },
    {
      image: RewardsFreeBillPayment,
      nbrPoint: 200,
      description: ' une paiement de facture sans frais',
      color: 'bg-[#38C3FF]',
      type: 'freeInvoice',
      redirection:'/paimentFacture'
    },
    {
      image: RewardFreeFraisT,
      nbrPoint: 1200,
      description: ' un transfert sans frais',
      color: 'bg-[#20C374]',
      type: 'freeTransfer',
      redirection:'/transfert/0'

    },
    // {image:RewardSpecialRate, nbrPoint:400,  description: 'Gagner 1 Transfert avec un Taux Préférentiel  ', color: 'bg-[#20C374]'},
  ]

  const fnCreateGift = async () => {
    if (user?.token?.accessToken && user?.user?._id && selectedPack) {
      const response = await CreateGift(user?.user?._id, user?.token.accessToken, selectedPack.type)

  if(response.message ==='Gift created successfully.')
  {
    setUser({
      ...user,
      user: {
        ...user.user,
        game: {
          ...user.user.game,
          balance: response.newBalance,
        },
      },
    })
    navigate(selectedPack.redirection)
  }

    }
  }

  useEffect(()=>{
    if(user?.user)
    setIsOpenRecompense(user?.user.game?.isOpenRecompense || false)
  },[user?.user.game])

  useEffect(()=>{
    const fetchData= async()=>{
      if(user?.user?._id && user?.token)
    {const response= await GetListGift(user?.user?._id, user?.token?.accessToken)
      setGiftCount(response.gifts)
      setTotalCount(response.summary.totalGifts)
    }
    }
    fetchData()
    
  },[user?.user?._id, user?.token])

  return (
    <div>
 
      <h1 className="h1 w-full lg:mt-[30px]">Boutique de récompenses</h1>
         
      {!isOpenRecompense?
      <div className="flex w-full  flex-col items-center justify-center mt-[50px] gap-6">
        <div className='flex w-full gap-3'>
        <div
          className="cursor-pointer border border-[#E2E2FB] rounded-[8px] h-[56px] w-full flex items-center justify-center gap-3"
          onClick={() => {
            if (!isOpenModalInfo) setIsOpenModalInfo(true)
          }}
        >
          <img src={ScoreIconRP} alt="Icône des points RP" />
          <div className="text-[8px] leading-4">
            RP points
            <br />
            <span className="text-[#FE9600] text-[16px] font-medium">
              {user?.user.game?.balance && user?.user.game?.balance > 0 ? user?.user.game?.balance :  0} RP
            </span>
          </div>
          <img src={Info} alt="Informations sur les points RP" />
        </div>
        <div 
          onClick={()=>(setIsOpenRecompense(true))}
          className='cursor-pointer h-[56px] relative px-3 flex items-center justify-center border border-[#E2E2FB] rounded-[8px]'> 
          <img className=' w-[48px] h-auto' width={24} height={24} src={GiftStore} alt=''/>
          <div className='bg-[#EE443F] absolute rounded-full w-[20px] h-[20px] right-2 top-0 text-[12px] text-white font-bold flex items-center justify-center'>{totalCount}</div>
        </div>
        </div>
        <h2 className="text-[#5754E5] font-bold text-[22px]">Convertissez vos RP </h2>
        <p className="text-[#6B7280] text-center text-[16px]">Utilisez vos Points de Récompense (RP)<br/> pour obtenir des avantages gratuits.</p>

        <div className=" space-y-6 px-[80px] lg:px-[20px] lg:w-full max-h-[500px] overflow-y-auto scrollbar-webkit py-4">
          {listeOffre.map((item, index) => (
            <div
              key={index}
              onClick={() => {
                if (user?.user?.game?.balance && item.nbrPoint <= user?.user?.game?.balance) {
                  setIsOpenModalSpendGift(true)
                  // if (item.montant) setSelectedPack(item.montant)
                  setSelectedPack(item)
                 
                }
              }}
              className={`${user?.user?.game?.balance && item.nbrPoint <= user?.user?.game?.balance ? 'cursor-pointer' : ' cursor-default opacity-50'} flex  items-center rounded-[8px] overflow-hidden  shadow-[0px_4px_15px_rgba(0,0,0,0.1)] pr-3`}
            >
              <div className="relative">
                <div className={`${item.color} absolute  w-[6px] h-full`} />
                <img src={item.image} width={134} height={134} alt="reward card" />
                
              </div>
              <div className=" flex flex-col gap-3 max-w-[280px] w-full">
                <p className=" text-[#666666] text-[15px] font-medium">Gagnez {item.description}</p>
                <div className=" flex items-center justify-center text-[12px] font-bold gap-3 border border-[#4D36CC] text-[#4D36CC] rounded-[8px]  h-[32px] w-full ">
                  Dépensez {item.nbrPoint} RP{' '}
                  <img className="h-[30px] w-auto" src={Fleche} width={32} height={33} alt="" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      :<Recompense 
      setIsOpenRecompense={setIsOpenRecompense} 
      liste={listeOffre} giftCount={giftCount} 
      handleSelected={fnCreateGift}
      />}
      {isOpenModalSpendGift && selectedPack  && (
        <SpendGiftModal  typeCarte={selectedPack}  isClosed={setIsOpenModalSpendGift} handleSelected={fnCreateGift} />
      )}

      {isOpenModalInfo && (
        <div className="bg-transparent inset-0 z-50 w-full h-screen">
          <ModalInfoReward setIsOpenModal={setIsOpenModalInfo} />
        </div>
      )}
    </div>
  )
}

export default Rewards
